const cardSlider = document.querySelectorAll('[data-slider="card-slider"]');

const cardSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
};

const initCardSlider = (el) => {
  const parentEle = el.closest('.card-slider');
  const selectedCols = Number(parentEle.getAttribute('data-select-col'));
  const horizontalCards = parentEle.querySelector('.showcase-card--horizontal');

  const arrowRight = parentEle.querySelector('.arrow-right');
  const arrowLeft = parentEle.querySelector('.arrow-left');
  const pagination = parentEle.querySelector('.swiper-pagination');
  const fallbackCols = selectedCols || 3;
  const isSingle = selectedCols === 1;

  const options = {
    ...cardSliderOptions,
    slidesPerView: isSingle ? 1 : 'auto',
    pagination: {
      ...cardSliderOptions.pagination,
      el: pagination,
    },
    navigation: {
      prevEl: arrowLeft,
      nextEl: arrowRight,
    },
    breakpoints: isSingle
      ? {
          767: { slidesPerView: 1, spaceBetween: 20 },
          1024: { slidesPerView: 1, spaceBetween: 20 },
          1199: { slidesPerView: 1, spaceBetween: 20 },
        }
      : {
          ...cardSliderOptions.breakpoints,
          1024: {
            slidesPerView: horizontalCards ? fallbackCols : 3,
            spaceBetween: 20,
          },
          1199: {
            slidesPerView: fallbackCols,
            spaceBetween: 20,
          },
        },
  };

  new Swiper(el, options);
};

cardSlider.forEach((el) => initCardSlider(el));

setupResponsiveSliders({
  sliderElements: cardSlider,
  breakpoint: breakpointSm,
  initSlider: initCardSlider,
  mobileFallback: [enableProgressSync, enableArrowScrollSync],
  parentSelector: '[data-slider-parent]',
});
